import React from 'react'
import { Header } from 'semantic-ui-react'
import { css } from 'react-emotion'

const styles = {
  header: css({
    color: '#888 !important',
    marginTop: '15px !important',
    marginBottom: '25px !important'
  }),
  links: css({
    margin: '16px 0',
    color: '#888',
    '> a': css({
      color: '#777',
      textDecoration: 'underline',
      marginLeft: '5px'
    })
  })
}

export const AuthHeader = ({title}) => (
  <Header as='h2' className={styles.header}>
    {title}
  </Header>
)

export const BottomLink = ({ text, link }) => (
  <div className={styles.links}>
    {text}
    {link}
  </div>
)


// WEBPACK FOOTER //
// ./src/Pages/Auth/AuthPartials.js